import * as React from 'react';

import SVGIcon from 'components/svg-icon/SVGIcon';

import { __t, applyTranslations } from 'utils/language';

import './audience-score.scss';

import type { StatisticsAudienceScore } from 'types';

applyTranslations(require('./audience-score.i18n.json'));

type Props = {
  scoreName: 'credibility' | 'reachability',
  scoreValue: StatisticsAudienceScore | undefined | null
};

class AudienceScore extends React.PureComponent<Props> {
  render() {
    const { scoreName, scoreValue } = this.props;

    if (!scoreValue) {
      return (
        <section className="audience-score audience-score--no-data">
          {__t('influencer_audience_score.no_data')}
        </section>
      );
    }

    return (
      <section className="audience-score">
        <div className="audience-score__subtitle">
          {__t(`influencer_audience_score.description_audience_${scoreName}`)}
        </div>
        <div className="audience-score__content">
          <div className="audience-score__value">
            <div className="audience-score__icon">
              <SVGIcon
                name={`audience-score-${scoreValue.replace(/_/g, '-')}`}
                width={102}
                height={102}
              />
            </div>
            {__t(`influencer_audience_score.${scoreName}_${scoreValue}`)}
          </div>
          <div className="audience-score__description">
            {__t(`influencer_audience_score.${scoreName}_desc_${scoreValue}`)}
          </div>
        </div>
      </section>
    );
  }
}

export default AudienceScore;
